import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { getActiveLanguage, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { TimePicker } from 'UI/Inputs';

var DatePickerFromTo = /*#__PURE__*/function (_Component) {
  _inherits(DatePickerFromTo, _Component);

  var _super = _createSuper(DatePickerFromTo);

  function DatePickerFromTo(props) {
    var _this;

    _classCallCheck(this, DatePickerFromTo);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.values != null) {
        if (nextProps.type == "assignment") {
          if (nextProps.values == null) {
            return;
          }

          _this.setState({
            timeStart: Moment.utc(nextProps.values.startDate).local(),
            timeEnd: Moment.utc(nextProps.values.dueDate).local(),
            dtPickerStartDate: Moment.utc(nextProps.values.startDate).local(),
            dtPickerDueDate: Moment.utc(nextProps.values.dueDate).local(),
            updated: true
          });
        } else if (nextProps.type == "plan") {
          if (nextProps.values == null) {
            return;
          }

          _this.setState({
            timeStart: nextProps.values.timeStart != null && !nextProps.cloneView ? Moment.utc(nextProps.values.timeStart).local() : Moment(),
            timeEnd: nextProps.values.timeEnd != null && !nextProps.cloneView ? Moment.utc(nextProps.values.timeEnd).local() : Moment().add(7, 'days'),
            dtPickerStartDate: nextProps.values.timeStart != null && !nextProps.cloneView ? Moment.utc(nextProps.values.timeStart).local() : Moment(),
            dtPickerDueDate: nextProps.values.timeEnd != null && !nextProps.cloneView ? Moment.utc(nextProps.values.timeEnd).local() : Moment().add(7, 'days'),
            updated: true
          });
        } else if (nextProps.type == "timeblocks") {
          _this.setState({
            timeStart: nextProps.values.startTime != null ? Moment.utc(nextProps.values.startTime).local() : Moment(),
            timeEnd: nextProps.values.endTime != null ? Moment.utc(nextProps.values.endTime).local() : Moment().add(7, 'days'),
            dtPickerStartDate: nextProps.values.startTime != null ? Moment.utc(nextProps.values.startTime).local() : Moment(),
            dtPickerDueDate: nextProps.values.endTime != null ? Moment.utc(nextProps.values.endTime).local() : Moment().add(7, 'days'),
            updated: false
          });
        } else if (nextProps.values.start != null && nextProps.values.end != null) {
          _this.setState({
            timeStart: Moment.utc(nextProps.values.start).local(),
            timeEnd: Moment.utc(nextProps.values.end).local(),
            dtPickerStartDate: Moment.utc(nextProps.values.start).local(),
            dtPickerDueDate: Moment.utc(nextProps.values.end).local(),
            updated: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.onChange();
    });

    _defineProperty(_assertThisInitialized(_this), "onStartChange", function (date) {
      var _this$state = _this.state,
          dtPickerStartDate = _this$state.dtPickerStartDate,
          timeStart = _this$state.timeStart,
          dtPickerDueDate = _this$state.dtPickerDueDate,
          timeEnd = _this$state.timeEnd;
      dtPickerStartDate = date;
      timeStart = date;
      var dueDate = Moment(date);

      if (date.diff(dtPickerDueDate) > 0) {
        dtPickerDueDate = Moment(date);
        timeEnd = Moment(date);
      }

      if (_this.props.type == "timeblocks") {
        if (!date.isSame(timeEnd, 'day')) {
          dtPickerDueDate = Moment(date);
          timeEnd = Moment(date);
        }
      }

      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEndChange", function (date) {
      var _this$state2 = _this.state,
          dtPickerDueDate = _this$state2.dtPickerDueDate,
          timeEnd = _this$state2.timeEnd,
          dtPickerStartDate = _this$state2.dtPickerStartDate,
          timeStart = _this$state2.timeStart;
      dtPickerDueDate = date;
      timeEnd = date;

      if (_this.props.type == "timeblocks") {
        if (!date.isSame(timeStart, 'day')) {
          dtPickerStartDate = Moment(date);
          timeStart = Moment(date);
        }
      }

      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStartTimeChange", function (time) {
      var _this$state3 = _this.state,
          dtPickerStartDate = _this$state3.dtPickerStartDate,
          timeStart = _this$state3.timeStart;
      dtPickerStartDate = Moment(time);
      timeStart = Moment(time);

      _this.setState({
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEndTimeChange", function (time) {
      var _this$state4 = _this.state,
          dtPickerDueDate = _this$state4.dtPickerDueDate,
          timeEnd = _this$state4.timeEnd;
      dtPickerDueDate = Moment(time);
      timeEnd = Moment(time);

      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        var dates = {
          start: _this.state.timeStart,
          end: _this.state.timeEnd
        };

        _this.props.onChange(dates);
      }
    });

    Moment.locale(getActiveLanguage());

    if (props.values != null && props.type == "assignment") {
      _this.state = {
        timeStart: props.values.startDate != null && !_this.props.cloneView ? Moment.utc(props.values.startDate).local() : Moment(),
        timeEnd: props.values.dueDate != null && !_this.props.cloneView ? Moment.utc(props.values.dueDate).local() : _this.props.values.startDate && !_this.props.cloneView ? Moment.utc(props.values.startDate).local().add(7, 'days') : Moment().add(7, 'days'),
        dtPickerStartDate: props.values.startDate != null && !_this.props.cloneView ? Moment.utc(props.values.startDate).local() : Moment(),
        dtPickerDueDate: props.values.dueDate != null && !_this.props.cloneView ? Moment.utc(props.values.dueDate).local() : _this.props.values.startDate && !_this.props.cloneView ? Moment.utc(props.values.startDate).local().add(7, 'days') : Moment().add(7, 'days'),
        updated: false
      };
    } else if (props.values != null && props.type == "plan") {
      _this.state = {
        timeStart: props.values.timeStart != null && !_this.props.cloneView ? Moment.utc(props.values.timeStart).local() : Moment(),
        timeEnd: props.values.timeEnd != null && !_this.props.cloneView ? Moment.utc(props.values.timeEnd).local() : Moment().add(7, 'days'),
        dtPickerStartDate: props.values.timeStart != null && !_this.props.cloneView ? Moment.utc(props.values.timeStart).local() : Moment(),
        dtPickerDueDate: props.values.timeEnd != null && !_this.props.cloneView ? Moment.utc(props.values.timeEnd).local() : Moment().add(7, 'days'),
        updated: false
      };
    } else if (props.values != null && props.values.start != null && props.values.end != null) {
      _this.state = {
        timeStart: props.values.start != null ? Moment.utc(props.values.start).local() : Moment(),
        timeEnd: props.values.end != null ? Moment.utc(props.values.end).local() : Moment().add(7, 'days'),
        dtPickerStartDate: props.values.start != null ? Moment.utc(props.values.start).local() : Moment(),
        dtPickerDueDate: props.values.end != null ? Moment.utc(props.values.end).local() : Moment().add(7, 'days'),
        updated: false
      };
    } else if (props.values != null && props.type == "timeblocks") {
      _this.state = {
        timeStart: props.values.startTime != null ? Moment.utc(props.values.startTime).local() : Moment(),
        timeEnd: props.values.endTime != null ? Moment.utc(props.values.endTime).local() : Moment().add(7, 'days'),
        dtPickerStartDate: props.values.startTime != null ? Moment.utc(props.values.startTime).local() : Moment(),
        dtPickerDueDate: props.values.endTime != null ? Moment.utc(props.values.endTime).local() : Moment().add(7, 'days'),
        updated: false
      };
    } else if (props.values == null && props.type == "timeblocks") {
      _this.state = {
        timeStart: Moment(),
        timeEnd: Moment(),
        dtPickerStartDate: Moment(),
        dtPickerDueDate: Moment(),
        updated: false
      };
    } else {
      _this.state = {
        timeStart: Moment(),
        timeEnd: Moment().add(7, 'days'),
        dtPickerStartDate: Moment(),
        dtPickerDueDate: Moment().add(7, 'days'),
        updated: false
      };
    }

    return _this;
  }

  _createClass(DatePickerFromTo, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, this.props.timePicker ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate('start')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerStartDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        selectsStart: true,
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.startDate))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: ""
      }, this.props.translate('start-time')), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-start-time'),
        time: this.state.dtPickerStartDate,
        onChange: this.onStartTimeChange
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate('start')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerStartDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-start",
        selectsStart: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.startDate)))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, this.props.timePicker ? /*#__PURE__*/React.createElement("div", null, !this.props.hideEndDate ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end"
      }, this.props.translate('end')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerDueDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        minDate: this.state.dtPickerStartDate,
        onChange: this.onEndChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-end",
        selectsEnd: true,
        showWeekNumbers: true,
        isClearable: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.endDate))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: ""
      }, this.props.translate('end-time')), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-end-time'),
        time: this.state.dtPickerDueDate,
        onChange: this.onEndTimeChange
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: ""
      }, this.props.translate('end-time')), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-end-time'),
        time: this.state.dtPickerDueDate,
        onChange: this.onEndTimeChange
      }))) : /*#__PURE__*/React.createElement("div", null, !this.props.hideEndDate ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end"
      }, this.props.translate('end')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerDueDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        minDate: this.state.dtPickerStartDate,
        onChange: this.onEndChange,
        popperPlacement: "bottom-end",
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.endDate))) : null)));
    }
  }]);

  return DatePickerFromTo;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps)(DatePickerFromTo);